import Toast from "../component/toastify/Index";
import axios from "./../axios/interceptor";

// SignIn API
export const signIn = async (payload) => {
  try {
    const response = await axios.post("/auth/login", payload);
    if (response?.data?.isSuccess) {
      return response.data;
    } else {
      Toast(response?.data?.message, "error");
    }
  } catch (error) {
    Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
  }
};

// Register New Account API
export const signUp = async (payload) => {
  try {
    delete payload.agb;
    const response = await axios.post("/auth/register", payload);
    if (response?.data?.isSuccess) {
      return response.data;
    } else {
      Toast(response?.data?.message, "error");
    }
  } catch (error) {
    Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
  }
};

// Forgot Password Send Verification Link API
export const sendPasswordVerification = async (payload) => {
  try {
    const response = await axios.post(
      "/auth/forgotPassword-verification",
      payload
    );
    if (response?.data?.isSuccess) {
      return response.data;
    } else {
      Toast(response?.data?.message, "error");
    }
  } catch (error) {
    Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
  }
};

// Forgot Password API
export const forgotPassword = async (payload, token) => {
  try {
    const response = await axios.post(`auth/forgotPassword/${token}`, payload);
    if (response?.data?.isSuccess) {
      return response.data;
    } else {
      Toast(response?.data?.message, "error");
    }
  } catch (error) {
    Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
  }
};

export const verifyEmail = async (email, token) => {
  try {
    const response = await axios.post(`/auth/verifyEmail/${email}/${token}`);
    if (response?.data?.isSuccess) {
      return response.data;
    } else {
      Toast(response?.data?.message, "error");
    }
  } catch (error) {
    Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
  }
};

export const resendVerifyEmail = async (email) => {
  try {
    const response = await axios.post(`/auth/resendVerifyEmail/${email}`);
    if (response?.data?.isSuccess) {
      return response.data;
    } else {
      Toast(response?.data?.message, "error");
    }
  } catch (error) {
    Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
  }
};
